import { SET_WIS_INCENTIVES } from '../actions/types';

export default function wisIncentive(state = {}, action) {
	if (!action.error) {
		const wisIncentives = action.payload;

		switch (action.type) {
			case SET_WIS_INCENTIVES:
				return wisIncentives;

			default:
		}
	}

	return state;
}
